import React from "react";
import { getAbsoluteImagePath } from "@utils/dom";
import { useConfig } from "@hooks";

type WidgetLayoutProps = { children: React.ReactNode };

const WidgetLayout: React.FC<WidgetLayoutProps> = ({ children }) => {
  const { mode: clientMode } = useConfig();
  const mode = clientMode ? clientMode : "vacanceole";

  return (
    <div
      className="tw-font-montserrat wrapperReservationPage"
      style={{
        backgroundImage: `url(${getAbsoluteImagePath(
          `/assets/img/customer/${mode === "vacanceole"
            ? ""
            : "background-form-corseole.png"
          }`
        )})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom left",
        backgroundSize: "100% 1500px",
      }}
    >
      {children}
    </div>
  );
};
export default WidgetLayout;
